import { Content } from '@rematter/ui-web';
import { useAtomValue } from 'jotai';

import { $ticketDirection } from '../../_state/scaleTicketPro.state';

import { InboundTicketList } from './inbound/_InboundTicketList';
import { OutboundTicketList } from './outbound/_OutboundTicketList';
import { ScaleTicketProView } from './shared/_ScaleTicketProView';

export const ScaleTicketListView = () => {
  const direction = useAtomValue($ticketDirection);

  return (
    <ScaleTicketProView className="@ScaleTicketListView">
      <Content className="flex h-full flex-col">
        {direction === 'inbound' ? (
          <InboundTicketList />
        ) : (
          <OutboundTicketList />
        )}
      </Content>
    </ScaleTicketProView>
  );
};
